module.exports = {"connectProblem":"Čaká sa na pripojenia..."}